import {
  SET_PROPERTIES_OF_THE_PLATFORM,
} from './mutations-types';

export default {
  setPropertiesOfThePlatform({ commit }, { lang, support_email, brand }) {
    commit(SET_PROPERTIES_OF_THE_PLATFORM, { lang, support_email, brand });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/global/actions.js